import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
const couponData: Record<string, {
  code: string;
  discountType: string;
  usageType: string;
  group: string;
  discountAmount: string;
  uses: string;
  expireDate: string;
  limitations: string;
  exceedAmount: string;
  created: string;
}> = {
  '2006': {
    code: '2006',
    discountType: 'dollar',
    usageType: 'per_customer',
    group: '',
    discountAmount: '19.95',
    uses: '',
    expireDate: '10/03/2020',
    limitations: 'single',
    exceedAmount: 'no',
    created: '01/01/2020'
  },
  '2007': {
    code: '2007',
    discountType: 'dollar',
    usageType: 'per_customer',
    group: '',
    discountAmount: '19.95',
    uses: '',
    expireDate: '09/18/2020',
    limitations: 'single',
    exceedAmount: 'no',
    created: '01/01/2020'
  }
};
const defaultCoupon = {
  code: 'AN270',
  discountType: 'percentage',
  usageType: 'unlimited_by_customer',
  group: 'PAR',
  discountAmount: '100.00',
  uses: '',
  expireDate: 'Not set',
  limitations: 'all',
  exceedAmount: 'no',
  created: '05/18/2021'
};
export function ViewCoupon() {
  const navigate = useNavigate();
  const {
    id
  } = useParams();
  const coupon = id && couponData[id] ? couponData[id] : defaultCoupon;
  const rows = [{
    label: 'Coupon Code',
    value: coupon.code
  }, {
    label: 'Discount Type',
    value: coupon.discountType
  }, {
    label: 'Usage Type',
    value: coupon.usageType
  }, {
    label: 'Group',
    value: coupon.group
  }, {
    label: 'Discount Amount',
    value: coupon.discountAmount
  }, {
    label: 'Uses',
    value: coupon.uses
  }, {
    label: 'Expire Date',
    value: coupon.expireDate
  }, {
    label: 'Limitations',
    value: coupon.limitations
  }, {
    label: 'Exceed Amount',
    value: coupon.exceedAmount
  }, {
    label: 'Created',
    value: coupon.created
  }];
  return <div className="space-y-4" data-id="element-2461" data-mp="2rl5s0ogto0y4">
      <div className="flex items-center justify-between" data-id="element-2462" data-mp="2rib951dgio6t">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2463" data-mp="2co6n58dcum7c">View Coupon</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/coupons')} data-id="element-2464" data-mp="2hlyiydh4esgt">
          ← Back to Coupons
        </Button>
      </div>

      <Card data-id="element-2465" data-mp="2vm96p7n4vqxr">
        <CardContent className="pt-6" data-id="element-2466" data-mp="2vmj0757e0g87">
          <h2 className="text-base font-semibold text-slate-800 mb-3" data-id="element-2467" data-mp="2vlg66oerpxo2">
            Coupon
          </h2>
          <table className="text-sm w-full max-w-lg" data-id="element-2468" data-mp="30j9fhqbdb7sk">
            <tbody data-id="element-2469" data-mp="3oaeszytu5nzp">
              {rows.map(({
              label,
              value
            }) => <tr key={label} className="border-b border-slate-100" data-id="element-2470" data-mp="3t1dah1qk8s4j">
                  <td className="py-2 pr-6 font-medium text-slate-700 w-36 align-top" data-id="element-2471" data-mp="3t2ogl87habyt">
                    {label}
                  </td>
                  <td className="py-2 text-slate-900" data-id="element-2472" data-mp="1cnl0camf50dl">{value}</td>
                </tr>)}
            </tbody>
          </table>

          <div className="mt-6 flex gap-3" data-id="element-2473" data-mp="1rawdui25uugc">
            <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate(`/coupons/edit/${id}`)} data-id="element-2474" data-mp="1md4ljmxlt6bm">
              Edit Coupon
            </Button>
            <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/coupons')} data-id="element-2475" data-mp="17nyljwqxzc2o">
              Back to List
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>;
}